var BaseView = require('../components/accordion-list/content');
var AnalyticsDecorate = require('../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('./analytics/backgrounds'), BaseView.extend({
  apiCall: 'search/backgrounds',
  dataName: 'backgroundCategories',
  callbackName: 'callbackImages',
  where: {},

  initialize: function (options) {
    this.category = options.key === 'all' ? 'all' : _.find(INKIVE.Tool._cache['backgroundCategories'],
      function (category) {
        return parseInt(category.id) === options.key;
      });

    BaseView.prototype.initialize.call(this, options);
  },

  getScrollHeight: function ($target) {
    var topMargin = 123;
    return $('#tool-panel').height() - this.$el.siblings().height() - topMargin;
  },

  getParams: function () {
    var params = {
      from: this.from,
      limit: this.limit,
      where: {
        category: this.category === 'all' ? null : this.category.name
      }
    };

    this.from += this.limit;

    return params;
  },

  extractData: function (data) {
    this.searchInput.removeClass('disabled');

    return _.map(data, function (item) {
      var imageData = this.getImageData(item);
      this.imagesFactory.addImageData(imageData);

      return {
        id: 'background-' + item['id'],
        src: imageData.version.thumb,
        cls: parseInt(item['active']) ? '' : ' grayscale',
        data: imageData,
        width: 125,
        height: 78
      };
    }, this);
  },

  getImageData: function (item) {
    return {
      name: item['readable_name'],
      count: item['count'],
      version: {
        original: item['url'],
        largeweb: item['url'],
        web: item['url'],
        tab: item['url'],
        mobile: item['url'] && item['url'].replace('-web', '-mobile'),
        thumb: item['url'] && item['url'].replace('-web', '-thumb')
      }
    };
  },

  render: function () {
    this.searchInput = this.$el.parents('.inner-tabs').find('input[name=search]').addClass('disabled');
    this.$el.html(this.template({
      placeholder: this.filterPlaceholder
    }));

    this.$el.find('.antiscroll-inner').addThumb();
  }
}));
